import styled, { keyframes } from 'styled-components';
import { NEUTRAL_100, GRAYSCALE_200 } from '../../styles/colors';

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SkeletonContainer = (styled.div`
  position: relative;
  overflow: hidden;
  background-color: ${NEUTRAL_100};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SkeletonAnimation = (styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    ${NEUTRAL_100} 25%,
    ${GRAYSCALE_200} 50%,
    ${NEUTRAL_100} 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
